export default {
	areaCodes: [
		{ code: '+86', desc: '+86 (CN)' },
		{ code: '+852', desc: '+852 (HK)' },
		{ code: '+376', desc: '+376 (AD)' },
		{ code: '+355', desc: '+355 (AL)' },
		{ code: '+43', desc: '+43 (AT)' },
		{ code: '+387', desc: '+387 (BA)' },
		{ code: '+32', desc: '+32 (BE)' },
		{ code: '+359', desc: '+359 (BG)' },
		{ code: '+375', desc: '+375 (BY)' },
		{ code: '+41', desc: '+41 (CH)' },
		{ code: '+420', desc: '+420 (CZ)' },
		{ code: '+49', desc: '+49 (DE)' },
		{ code: '+45', desc: '+45 (DK)' },
		{ code: '+372', desc: '+372 (EE)' },
		{ code: '+34', desc: '+34 (ES)' },
		{ code: '+358', desc: '+358 (FI)' },
		{ code: '+33', desc: '+33 (FR)' },
		{ code: '+44', desc: '+44 (GB)' },
		{ code: '+30', desc: '+30 (GR)' },
		{ code: '+36', desc: '+36 (HU)' },
		{ code: '+353', desc: '+353 (IE)' },
		{ code: '+354', desc: '+354 (IS)' },
		{ code: '+39', desc: '+39 (IT)' },
		{ code: '+423', desc: '+423 (LI)' },
		{ code: '+370', desc: '+370 (LT)' },
		{ code: '+352', desc: '+352 (LU)' },
		{ code: '+371', desc: '+371 (LV)' },
		{ code: '+377', desc: '+377 (MC)' },
		{ code: '+373', desc: '+373 (MD)' },
		{ code: '+382', desc: '+382 (ME)' },
		{ code: '+389', desc: '+389 (MK)' },
		{ code: '+356', desc: '+356 (MT)' },
		{ code: '+47', desc: '+47 (NO)' },
		{ code: '+31', desc: '+31 (NL)' },
		// { code: '+48', desc: '+48 (PE)' },
		{ code: '+40', desc: '+40 (RO)' },
		{ code: '+351', desc: '+351 (PT)' },
		{ code: '+7', desc: '+7 (RU)' },
		{ code: '+385', desc: '+385 (HR)' },
		{ code: '+386', desc: '+386 (SI)' },
		{ code: '+421', desc: '+421 (SK)' },
		{ code: '+378', desc: '+378 (SM)' },
		{ code: '+381', desc: '+381 (RS)' },
		{ code: '+46', desc: '+46 (SE)' },
		{ code: '+380', desc: '+380 (UA)' },
		// 新增 产品：谢莉萍
		{ 'code': '+1', 'desc': '+1 (CA)' },
		{ 'code': '+1', 'desc': '+1 (US)' },
		{ 'code': '+7', 'desc': '+7 (KZ)' },
		{ 'code': '+20', 'desc': '+20 (EG)' },
		{ 'code': '+27', 'desc': '+27 (ZA)' },
		// { 'code': '+32', 'desc': '+32 (GB)' },
		// { 'code': '+33', 'desc': '+33 (VE)' },
		// { 'code': '+34', 'desc': '+34 (PH)' },
		// { 'code': '+36', 'desc': '+36 (KR)' },
		// { 'code': '+39', 'desc': '+39 (IR)' },
		// { 'code': '+40', 'desc': '+40 (GM)' },
		{ 'code': '+48', 'desc': '+48 (PL)' },
		{ 'code': '+51', 'desc': '+51 (PE)' },
		{ 'code': '+52', 'desc': '+52 (MX)' },
		{ 'code': '+53', 'desc': '+53 (CU)' },
		{ 'code': '+54', 'desc': '+54 (AR)' },
		{ 'code': '+55', 'desc': '+55 (BR)' },
		{ 'code': '+56', 'desc': '+56 (CL)' },
		{ 'code': '+57', 'desc': '+57 (CO)' },
		{ 'code': '+58', 'desc': '+58 (VE)' },
		{ 'code': '+60', 'desc': '+60 (MY)' },
		{ 'code': '+61', 'desc': '+61 (AU)' },
		{ 'code': '+62', 'desc': '+62 (ID)' },
		{ 'code': '+63', 'desc': '+63 (PH)' },
		{ 'code': '+64', 'desc': '+64 (NZ)' },
		{ 'code': '+65', 'desc': '+65 (SG)' },
		{ 'code': '+66', 'desc': '+66 (TH)' },
		{ 'code': '+81', 'desc': '+81 (JP)' },
		{ 'code': '+82', 'desc': '+82 (KR)' },
		{ 'code': '+84', 'desc': '+84 (VN)' },
		{ 'code': '+90', 'desc': '+90 (TR)' },
		{ 'code': '+91', 'desc': '+91 (IN)' },
		{ 'code': '+92', 'desc': '+92 (PK)' },
		{ 'code': '+93', 'desc': '+93 (AF)' },
		{ 'code': '+94', 'desc': '+94 (LK)' },
		{ 'code': '+95', 'desc': '+95 (MM)' },
		{ 'code': '+98', 'desc': '+98 (IR)' },
		{ 'code': '+211', 'desc': '+211 (SS)' },
		{ 'code': '+212', 'desc': '+212 (MA)' },
		{ 'code': '+213', 'desc': '+213 (DZ)' },
		{ 'code': '+216', 'desc': '+216 (TN)' },
		{ 'code': '+218', 'desc': '+218 (LY)' },
		{ 'code': '+220', 'desc': '+220 (GM)' },
		{ 'code': '+221', 'desc': '+221 (SN)' },
		{ 'code': '+222', 'desc': '+222 (MR)' },
		{ 'code': '+223', 'desc': '+223 (ML)' },
		{ 'code': '+224', 'desc': '+224 (GN)' },
		{ 'code': '+225', 'desc': '+225 (CI)' },
		{ 'code': '+226', 'desc': '+226 (BF)' },
		// { 'code': '+227', 'desc': '+227 (NC)' },
		{ 'code': '+228', 'desc': '+228 (TG)' },
		{ 'code': '+229', 'desc': '+229 (BJ)' },
		{ 'code': '+230', 'desc': '+230 (MU)' },
		{ 'code': '+231', 'desc': '+231 (LR)' },
		{ 'code': '+232', 'desc': '+232 (SL)' },
		{ 'code': '+233', 'desc': '+233 (GH)' },
		{ 'code': '+234', 'desc': '+234 (NG)' },
		{ 'code': '+235', 'desc': '+235 (TD)' },
		{ 'code': '+236', 'desc': '+236 (CF)' },
		{ 'code': '+237', 'desc': '+237 (CM)' },
		{ 'code': '+238', 'desc': '+238 (CV)' },
		{ 'code': '+239', 'desc': '+239 (ST)' },
		{ 'code': '+240', 'desc': '+240 (GQ)' },
		{ 'code': '+241', 'desc': '+241 (GA)' },
		{ 'code': '+242', 'desc': '+242 (CG)' },
		{ 'code': '+243', 'desc': '+243 (CD)' },
		{ 'code': '+244', 'desc': '+244 (AO)' },
		{ 'code': '+245', 'desc': '+245 (GW)' },
		{ 'code': '+248', 'desc': '+248 (SC)' },
		{ 'code': '+249', 'desc': '+249 (SD)' },
		{ 'code': '+250', 'desc': '+250 (RW)' },
		{ 'code': '+251', 'desc': '+251 (ET)' },
		{ 'code': '+252', 'desc': '+252 (SO)' },
		{ 'code': '+253', 'desc': '+253 (DJ)' },
		{ 'code': '+254', 'desc': '+254 (KE)' },
		{ 'code': '+255', 'desc': '+255 (TZ)' },
		{ 'code': '+256', 'desc': '+256 (UG)' },
		{ 'code': '+257', 'desc': '+257 (BI)' },
		{ 'code': '+258', 'desc': '+258 (MZ)' },
		{ 'code': '+260', 'desc': '+260 (ZM)' },
		{ 'code': '+261', 'desc': '+261 (MG)' },
		{ 'code': '+262', 'desc': '+262 (RE)' },
		{ 'code': '+263', 'desc': '+263 (ZW)' },
		{ 'code': '+264', 'desc': '+264 (NA)' },
		{ 'code': '+265', 'desc': '+265 (MW)' },
		{ 'code': '+266', 'desc': '+266 (LS)' },
		{ 'code': '+267', 'desc': '+267 (BW)' },
		{ 'code': '+268', 'desc': '+268 (SZ)' },
		{ 'code': '+269', 'desc': '+269 (KM)' },
		{ 'code': '+269', 'desc': '+269 (YT)' },
		{ 'code': '+297', 'desc': '+297 (AW)' },
		{ 'code': '+299', 'desc': '+299 (GL)' },
		{ 'code': '+350', 'desc': '+350 (GI)' },
		{ 'code': '+357', 'desc': '+357 (CY)' },
		{ 'code': '+374', 'desc': '+374 (AM)' },
		{ 'code': '+501', 'desc': '+501 (BZ)' },
		{ 'code': '+502', 'desc': '+502 (GT)' },
		{ 'code': '+503', 'desc': '+503 (SV)' },
		{ 'code': '+504', 'desc': '+504 (HN)' },
		{ 'code': '+505', 'desc': '+505 (NI)' },
		{ 'code': '+506', 'desc': '+506 (CR)' },
		{ 'code': '+507', 'desc': '+507 (PA)' },
		{ 'code': '+508', 'desc': '+508 (PM)' },
		{ 'code': '+509', 'desc': '+509 (HT)' },
		{ 'code': '+590', 'desc': '+590 (GP)' },
		{ 'code': '+591', 'desc': '+591 (BO)' },
		{ 'code': '+592', 'desc': '+592 (GY)' },
		{ 'code': '+593', 'desc': '+593 (EC)' },
		{ 'code': '+594', 'desc': '+594 (GF)' },
		{ 'code': '+595', 'desc': '+595 (PY)' },
		{ 'code': '+596', 'desc': '+596 (MQ)' },
		{ 'code': '+597', 'desc': '+597 (SR)' },
		{ 'code': '+598', 'desc': '+598 (UY)' },
		{ 'code': '+670', 'desc': '+670 (TL)' },
		{ 'code': '+673', 'desc': '+673 (BN)' },
		{ 'code': '+675', 'desc': '+675 (PG)' },
		{ 'code': '+676', 'desc': '+676 (TO)' },
		{ 'code': '+677', 'desc': '+677 (SB)' },
		{ 'code': '+678', 'desc': '+678 (VU)' },
		{ 'code': '+679', 'desc': '+679 (FJ)' },
		{ 'code': '+680', 'desc': '+680 (PW)' },
		{ 'code': '+685', 'desc': '+685 (WS)' },
		{ 'code': '+686', 'desc': '+686 (KI)' },
		{ 'code': '+687', 'desc': '+687 (NC)' },
		{ 'code': '+689', 'desc': '+689 (PF)' },
		{ 'code': '+853', 'desc': '+853 (MO)' },
		{ 'code': '+855', 'desc': '+855 (KH)' },
		{ 'code': '+856', 'desc': '+856 (LA)' },
		{ 'code': '+880', 'desc': '+880 (BD)' },
		{ 'code': '+886', 'desc': '+886 (TW)' },
		{ 'code': '+970', 'desc': '+970 (PS)' },
		{ 'code': '+960', 'desc': '+960 (MV)' },
		{ 'code': '+961', 'desc': '+961 (LB)' },
		{ 'code': '+962', 'desc': '+962 (JO)' },
		{ 'code': '+963', 'desc': '+963 (SY)' },
		{ 'code': '+964', 'desc': '+964 (IQ)' },
		{ 'code': '+965', 'desc': '+965 (KW)' },
		{ 'code': '+966', 'desc': '+966 (SA)' },
		{ 'code': '+967', 'desc': '+967 (YE)' },
		{ 'code': '+968', 'desc': '+968 (OM)' },
		{ 'code': '+971', 'desc': '+971 (AE)' },
		{ 'code': '+972', 'desc': '+972 (IL)' },
		{ 'code': '+973', 'desc': '+973 (BH)' },
		{ 'code': '+974', 'desc': '+974 (QA)' },
		{ 'code': '+975', 'desc': '+975 (BT)' },
		{ 'code': '+976', 'desc': '+976 (MN)' },
		{ 'code': '+977', 'desc': '+977 (NP)' },
		{ 'code': '+992', 'desc': '+992 (TJ)' },
		{ 'code': '+993', 'desc': '+993 (TM)' },
		{ 'code': '+994', 'desc': '+994 (AZ)' },
		{ 'code': '+995', 'desc': '+995 (GE)' },
		{ 'code': '+996', 'desc': '+996 (KG)' },
		{ 'code': '+998', 'desc': '+998 (UZ)' },
		{ 'code': '+1242', 'desc': '+1242 (BS)' },
		{ 'code': '+1246', 'desc': '+1246 (BB)' },
		{ 'code': '+1264', 'desc': '+1264 (AI)' },
		{ 'code': '+1268', 'desc': '+1268 (AG)' },
		{ 'code': '+1441', 'desc': '+1441 (BM)' },
		{ 'code': '+1473', 'desc': '+1473 (GD)' },
		{ 'code': '+1664', 'desc': '+1664 (MS)' },
		{ 'code': '+1671', 'desc': '+1671 (GU)' },
		{ 'code': '+1684', 'desc': '+1684 (AS)' },
		{ 'code': '+1758', 'desc': '+1758 (LC)' },
		{ 'code': '+1767', 'desc': '+1767 (DM)' },
		{ 'code': '+1784', 'desc': '+1784 (VC)' },
		{ 'code': '+1787', 'desc': '+1787 (PR)' },
		{ 'code': '+1809', 'desc': '+1809 (DO)' },
		{ 'code': '+1868', 'desc': '+1868 (TT)' },
		{ 'code': '+1869', 'desc': '+1869 (KN)' },
		{ 'code': '+1876', 'desc': '+1876 (JM)' }
	]
}
